import { MobileScrollWrapper } from 'components/mobile/MobileScrollWrapper';
import { MinuteEditorLayout } from 'elements/layout/minute/MinuteEditorLayout';
import { useLinkMapAndGuideToUser } from 'hooks/ownership/useLinkMapAndGuideToUser';
import { setCookie } from 'libs/utils/logic/operations/storageOperations';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { CtxApp } from 'session/ctxApp';
import { GlobalContext } from 'session/state/context';
import { LOCAL_STORAGE_LANGUAGE } from 'static/config/coreConfig';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export const MinutePage = (): JSX.Element => {
    const { state } = useContext(GlobalContext);
    const ctxApp = useContext(CtxApp);
    const { id } = useParams() as { id: string };

    useLinkMapAndGuideToUser();

    useEffect(() => {
        const language = Localization.getLanguage();
        if (language !== 'cs' && language !== 'en') {
            setCookie(LOCAL_STORAGE_LANGUAGE, 'en');
            Localization.setLanguage('en');
            ctxApp.setLanguage('en');
        }
    }, []);

    if (!state.loggedUserChecked) {
        return <></>;
    }

    return (
        <MobileScrollWrapper>
            <S_MinutePage className="givememap">
                {<MinuteEditorLayout worldMapId={id} />}
            </S_MinutePage>
        </MobileScrollWrapper>
    );
};

const S_MinutePage = styled(S_PageStyle)`
    min-width: 1260px;
`;
